import { SetupHandlers, SetupServices } from "./runtime.js"
import { createContainerHandlers } from "./container/index.js"
import { createDependencyHandlers } from "./dependencies/index.js"
import { createPrototypeHandlers } from "./prototype/index.js"
import { createScanHandlers } from "./scan/index.js"

export function createSetupHandlers(services: SetupServices): SetupHandlers {
  return {
    ...createScanHandlers(services),
    ...createContainerHandlers(services),
    ...createDependencyHandlers(services),
    ...createPrototypeHandlers(services),
  }
}
